import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { compose, setDisplayName } from 'recompose';

import { Row, Column } from 'styled-components-reactive-grid';

import withCustomerFromCall from '../withCustomerFromCall';
import CustomStoreCustomer from './CustomStoreCustomer';
import CustomerSelector from './CustomerSelector';
import OtherCustomer from './OtherCustomer';
import StoreCustomerSelector from './StoreCustomerSelector';

function getCustomerInputForType(customerType, customerTypes) {
  switch (customerType) {
    case get(customerTypes, 'NATIONAL.type'):
      return CustomerSelector;
    case get(customerTypes, 'STORE.type'):
      return StoreCustomerSelector;
    case get(customerTypes, 'CUSTOM_STORE.type'):
      return CustomStoreCustomer;
    case get(customerTypes, 'OTHER.type'):
      return OtherCustomer;
    default:
      return CustomerSelector;
  }
}

export function CustomerInput({ customerType, ...rest }) {
  const CustomerInputForType = getCustomerInputForType(
    customerType,
    rest.customerTypes,
  );

  return (
    <Row>
      <Column modifiers={['col']}>
        <CustomerInputForType {...rest} />
      </Column>
    </Row>
  );
}

CustomerInput.propTypes = {
  caseNumber: PropTypes.string.isRequired,
  customerType: PropTypes.string.isRequired,
  customerTypes: PropTypes.objectOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
};

export default compose(
  setDisplayName('CustomerInput'),
  withCustomerFromCall,
)(CustomerInput);



// WEBPACK FOOTER //
// ./src/compositions/CustomerWidget/CustomerInput/index.js